import React from "react";

const LinkedIn = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50001 20.4737H0.249996V7.09869H4.50001V20.4737ZM2.375 5.22369C1 5.22369 0 4.22369 0 2.84869C0 1.47369 1.125 0.473694 2.375 0.473694C3.75 0.473694 4.75 1.47369 4.75 2.84869C4.75 4.22369 3.75 5.22369 2.375 5.22369ZM20 20.4737H15.75V13.2237C15.75 11.0987 14.875 10.4737 13.625 10.4737C12.375 10.4737 11.125 11.4737 11.125 13.3487V20.4737H6.875V7.09869H10.875V8.97369C11.25 8.09869 12.75 6.72369 14.875 6.72369C17.25 6.72369 19.75 8.09869 19.75 12.2237V20.4737H20Z"
        fill="#123333"
      />
    </svg>
  );
};

export default LinkedIn;
